import { connect } from 'react-redux';
import { dispatchify } from 'common/utils/utils';
import { toggleSnackBar } from 'state/callers';
import SnackBar from './SnackBar';

const mapStateToProps = state => {
  const { uiState } = state;
  return {
    uiState
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...dispatchify(dispatch, {
      toggleSnackBar
    })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);
